var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priority-item queue-failed" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-50" }, [
      _c("i", { staticClass: "far fa-times queue-icon lh-inherit" }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Oops, this didn't work")))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")(
              "It looks like there was an issue. We dispatched our seal team to solve this issue."
            )
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _vm.currentJob.apiJob?.status.code === "failed" && _vm.isFreeUser
      ? _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Queue overload!")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentJob.apiJob?.status.code === "failed" && _vm.isFreeUser
      ? _c("p", { staticClass: "font-weight-bold" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "We are happy that so many users are using this service and have already dispatched our seal team to order new servers."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentJob.apiJob?.status.code === "failed" && _vm.isFreeUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get a subscription to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(_vm._f("trans")("No Credits have been deducted.")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _vm.currentJob.apiJob?.status.code === "failed" && _vm.isFreeUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get Premium")))]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }